module.exports = __webpack_public_path__ + "static/img/2.f450e90.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/sp/2.png
// module id = u8Wz
// module chunks = 0